import React from "react";


const initState = 
{
    //rayons : [{name:'Photovoltaique',quantity:0,img:'/images/icons/pv.png'},{name:'Construction',quantity:0,img:'/images/icons/btp.jpg'},{name:'Beauté',quantity:0,img:'/images/icons/beaute.jpg'}],
    filtres : {allitems:[],setToDisplay:()=>{}},
};

const initUser = {auth:false,is_staff:false,labelname:"Espace Client",panier:{articles:[],lastview:[]}, messages_counter:0, notifications:[],notifs_counter:0}

export const AppContext = React.createContext(initState);
export const UserContext = React.createContext(initUser);